<template>
    <List />
</template>

<script>
import appConfig from '@/app.config'
import  List from '../../components/superAdmin/list/index.vue'
export default {
   page: {
    title: 'کنبان بورد',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'list',
  components: {
    List,
  },
}
</script>

